import { CopyOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import ModalComponent from "../common/Modal/modal";
import { useSelector } from "react-redux";
import { authSelector } from "../../store/slices/auth";

const FormDataCardMobile = (props: any) => {
    const { data, permissionParams, addData, onActions, projectData, addVariable } = props;
    const [permissionData, SetPermissionData] = useState<any>({});
    const projectDataPerm = useSelector(authSelector)

    const [moreOption, setmoreOption] = useState(false);
    useEffect(() => {
        console.log(projectDataPerm, projectData)
        console.log("Data_____))))", projectDataPerm.projectPermissionData?.filter(itm => itm.projectId == props.projectData.id))
        let perData = projectDataPerm.projectPermissionData?.filter(itm => itm.projectId == props.projectData.id)
        let permArray = {};
        perData && perData[0]?.permissionData.forEach((obj) => {
            if (Object.keys(obj)[0] == "Tabs") {
                obj[Object.keys(obj)[0]].forEach((objItem) => {
                    permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected
                })
                //setPermission(obj[Object.keys(obj)[0]])
            } else if (Object.keys(obj)[0] == "Forms") {
                obj[Object.keys(obj)[0]].forEach((objItem) => {
                    permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected
                })
            }
        })
        console.log(permArray)
        SetPermissionData(permArray)
    }, []);

    const onClose = () => {
        setmoreOption(false)
    }



    return (
        <>
            <div className="form-record-container">
                <div className="form-head">
                    <div className="form-name">
                        <span id="label">Form Name : </span>
                        <span id="label-name">{data.form_name}</span>
                    </div>

                    <div className={moreOption ? "more-options-open" : "more-options"} >
                        {
                            moreOption ?
                                <div className="more-container" onClick={() => setmoreOption(false)}>
                                    <div className="form-actions">
                                        {
                                            permissionParams && permissionParams['view data'] || Object.keys(permissionParams).length == 0 ?
                                                <div className="view" onClick={() => onActions(1, data)}>

                                                    <i
                                                        className="icon icon-eye"
                                                    ></i>
                                                    <span id="label-tag">View</span>
                                                </div>

                                                : ""
                                        }
                                        {
                                            permissionParams && permissionParams['edit form'] || Object.keys(permissionParams).length == 0 ?
                                                !data?.permission || data?.permission == "write" ?
                                                    !data.locked ?
                                                        <div className="edit" onClick={() => onActions(2, data)}>
                                                            <i
                                                                className="icon icon-edit"
                                                            ></i>
                                                            <span id="label-tag">Edit</span>
                                                        </div>
                                                        : "-"
                                                    : ""
                                                : ""
                                        }
                                        {
                                            permissionParams && permissionParams['delete form'] || Object.keys(permissionParams).length == 0 ?
                                                !data?.permission || data?.permission == "write" ?
                                                    !data.locked ?
                                                        <div className="delete" onClick={() => onActions(3, data)}>

                                                            <i
                                                                className="icon icon-delete"
                                                            ></i>

                                                            <span id="label-tag">Delete</span>
                                                        </div>
                                                        : "-"
                                                    : ""
                                                :
                                                ""
                                        }

                                        {
                                            permissionParams && permissionParams['Add rules'] || Object.keys(permissionParams).length == 0 ?
                                                <>
                                                    <div className="delete" onClick={() => onActions("rules", data)}>
                                                        <i
                                                            className="icon icon-add"
                                                        ></i>
                                                        <span id="label-tag">Add Rule</span>
                                                    </div> </>
                                                : ""
                                        }



                                        {
                                            permissionData && permissionData.length > 0 && !permissionParams['view data'] && !permissionParams['delete form'] && !permissionParams['edit form'] ?
                                                <div style={{ color: "#ccc" }}>No Permissions</div>
                                                : ""
                                        }
                                    </div>

                                </div> : ""
                        }


                        <i className={moreOption ? "icon icon-close" : "icon icon-more"} onClick={() => setmoreOption(!moreOption)}></i>

                    </div>
                </div>

                <div className="form-records">
                    <span id="label-tag">Records</span>
                    <span id="label-tag-count">{data.total_responses}</span>
                    {
                        permissionParams && permissionParams['Add data button'] || Object.keys(permissionParams).length == 0 ?
                            <span id="label-btn-add" onClick={() => addData(data)}>Add</span>
                            : ""
                    }
                </div>
                <div className="form-variables">
                    <span id="label-tag">Variables</span>
                    <span id="label-tag-name"> </span>
                    {
                        permissionParams && permissionParams['update form button'] || Object.keys(permissionParams).length == 0 ?
                            !data?.permission || data?.permission == "write" ?
                                !data.locked ?
                                    <span id="label-btn-update" onClick={() => addVariable(data)}>Update</span>
                                    : "-"
                                : ""
                            : ""
                    }
                </div>
                <div className="form-info">
                    <div className="survey">
                        <span id="label-tag">Survey</span>
                        {
                            permissionParams && permissionParams['survey link button'] || Object.keys(permissionParams).length == 0 ?
                                data.survey_form ? (
                                    <i
                                        className="icon icon-copy"
                                        onClick={() => onActions(5, data)}
                                    ></i>
                                ) : "-" : (
                                    <>-</>)
                        }

                    </div>
                    <div className="islocked">
                        <span id="label-tag">IsLocked</span>
                        {
                            projectData?.strict_mode == true ?
                                data.locked ?
                                    permissionParams && permissionParams['Lock'] || Object.keys(permissionParams).length == 0 ?

                                        <i className="icon icon-lock" onClick={() => onActions("unlock", data)}></i> : ""
                                    :
                                    permissionParams && permissionParams['Unlock'] || Object.keys(permissionParams).length == 0 ?

                                        <i className="icon icon-lock_open" onClick={() => onActions("lock", data)}></i> : ""
                                : "-"
                        }

                    </div>
                    <div className="clone">
                        <span id="label-tag">Clone</span>
                        <div className="clone-icon">
                            {
                                permissionParams && permissionParams['Clone'] || Object.keys(permissionParams).length == 0 ?
                                    <CopyOutlined onClick={() => onActions("duplicate", data)} />
                                    : "-"
                            }
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default FormDataCardMobile;